/* load-more.js — revision v2.2 (stable, no URL change, restore only on back) */
let SF_isLoading = false;
let SF_loadingUrl = null;      // URL en cours de chargement
let SF_loadedUrls = new Set(); // anti-doublon strict
let SF_observer = null;

(function () {
  var DEBUG = false;

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, arguments); } catch (e) {}
  }

  // ------------------ helpers ------------------
  function getDataBlock() {
    // infinite_scroll : bloc dédié
    var el = document.querySelector('.infinite-scroll__data');
    if (el) return el;

    // load_more : inputs “globaux” (ils sont au même niveau que le bouton)
    var next = document.querySelector('input[data-next-url]');
    return (next && next.parentElement) ? next.parentElement : document.body;
  }

  function getPaging() {
    var block = getDataBlock();
    var nextUrl = (block.querySelector('input[data-next-url]') || {}).value || '';
    var totalPages = parseInt(((block.querySelector('input[data-total-pages]') || {}).value || '1'), 10);
    var currentPage = parseInt(((block.querySelector('input[data-current-page]') || {}).value || '1'), 10);

    if (!Number.isFinite(totalPages)) totalPages = 1;
    if (!Number.isFinite(currentPage)) currentPage = 1;

    return { nextUrl: nextUrl, totalPages: totalPages, currentPage: currentPage };
  }

  function getStateKey() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      return 'collState:' + url.pathname + '?' + url.searchParams.toString();
    } catch (e) {
      return 'collState:' + window.location.pathname;
    }
  }
  var STATE_KEY = getStateKey();

  function readState() {
    try {
      var raw = sessionStorage.getItem(STATE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function saveState(patch) {
    var state = readState() || {};
    state.scrollY = window.scrollY || 0;

    var paging = getPaging();
    state.loadedPage = paging.currentPage || 1;

    state.ts = Date.now();

    if (patch && typeof patch === 'object') {
      for (var k in patch) state[k] = patch[k];
    }

    try { sessionStorage.setItem(STATE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  function shouldRestoreFromBack() {
    var navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
    var navType = navEntries && navEntries[0] && navEntries[0].type;
    return navType === 'back_forward';
  }

  async function waitNextFrame(times) {
    times = times || 1;
    for (var i = 0; i < times; i++) {
      await new Promise(function (res) { requestAnimationFrame(res); });
    }
  }

  // ------------------ loader (Promise) ------------------
  function loadItemsAsync(triggerEl, opts) {
    opts = opts || {};
    var silent = !!opts.silent;

    return new Promise(function (resolve) {
      if (SF_isLoading) return resolve(false);

      var paging = getPaging();
      var nextUrl = paging.nextUrl;
      var totalPages = paging.totalPages;
      var currentPage = paging.currentPage;

      if (!nextUrl || currentPage >= totalPages) {
        if (triggerEl && triggerEl.remove) triggerEl.remove();
        return resolve(false);
      }

      // Anti-doublon béton :
      // - si l’URL est déjà chargée => on stop
      // - si l’URL est en cours => on stop
      if (SF_loadedUrls.has(nextUrl) || SF_loadingUrl === nextUrl) {
        return resolve(false);
      }

      SF_isLoading = true;
      SF_loadingUrl = nextUrl;

      if (!silent && triggerEl) {
        triggerEl.setAttribute('disabled', '');
        triggerEl.classList.add('loading');
      }

      $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html'
      })
      .done(function (html) {
        var $resp = $(html);

        // 1) append produits
        var $newGrid = $resp.find('.load-more-grid');
        if ($newGrid.length) {
          $('.load-more-grid').append($newGrid.html());
        }

        if (typeof colorSwatches === 'function') colorSwatches();

        // 2) update data block (infinite_scroll)
        var $newData = $resp.find('.infinite-scroll__data');
        if ($newData.length) {
          $('.infinite-scroll__data').html($newData.html());
        } else {
          // fallback load_more (inputs hors wrapper)
          var block = getDataBlock();
          var newNext = $resp.find('input[data-next-url]').val();
          var newTotal = $resp.find('input[data-total-pages]').val();
          var newCurrent = $resp.find('input[data-current-page]').val();
          if (newNext) (block.querySelector('input[data-next-url]') || {}).value = newNext;
          if (newTotal) (block.querySelector('input[data-total-pages]') || {}).value = newTotal;
          if (newCurrent) (block.querySelector('input[data-current-page]') || {}).value = newCurrent;
        }

        // Marque l’URL comme chargée UNIQUEMENT après succès complet
        SF_loadedUrls.add(nextUrl);

        // Sauvegarde d’état après ajout
        saveState({ fromProduct: false });
      })
      .fail(function (xhr, status, err) {
        console.error('Échec du chargement :', err);
        // en cas d’échec, on autorise retry : on ne met pas dans SF_loadedUrls
      })
      .always(function () {
        SF_isLoading = false;
        SF_loadingUrl = null;

        if (!silent && triggerEl) {
          triggerEl.removeAttribute('disabled');
          triggerEl.classList.remove('loading');
        }

        // Re-arm observer si encore des pages
        var updated = getPaging();
        if (updated.currentPage < updated.totalPages) {
          armObserver();
        } else {
          // fin : retire spinner/bouton
          var spinner = document.querySelector('.js-infinite-scroll');
          if (spinner) spinner.remove();
          if (triggerEl && triggerEl.remove) triggerEl.remove();
        }

        resolve(true);
      });
    });
  }

  // ------------------ observer (infinite only) ------------------
  function armObserver() {
    // Si pas de spinner => pas de infinite scroll (probablement load_more)
    var spinner = document.querySelector('.js-infinite-scroll');
    if (!spinner) return;

    // Un seul observer
    if (SF_observer) SF_observer.disconnect();

    SF_observer = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            loadItemsAsync(spinner);
          }
        });
      },
      { rootMargin: '200px' }
    );

    SF_observer.observe(spinner);
  }

  // ------------------ load more button ------------------
  function bindLoadMoreButton() {
    document.querySelectorAll('.js-load-more').forEach(function (btn) {
      btn.onclick = function () {
        loadItemsAsync(btn);
      };
    });
  }

  // ------------------ restore on back ------------------
  async function restoreOnBack() {
    var state = readState();
    if (!state || !state.fromProduct) return;
    if (state.ts && (Date.now() - state.ts) > 1000 * 60 * 30) return;

    var targetPage = Math.max(1, parseInt(state.loadedPage || 1, 10));
    var targetScrollY = Math.max(0, parseInt(state.scrollY || 0, 10));

    // IMPORTANT : on repart “comme si page 1”, puis on recharge jusqu’à targetPage
    // => on a bien les pages 1..N dans le DOM (et pas seulement page N)
    var paging = getPaging();
    var currentPage = paging.currentPage || 1;

    for (var p = currentPage; p < targetPage; p++) {
      await loadItemsAsync(null, { silent: true });
      await waitNextFrame(1);
    }

    await waitNextFrame(2);
    window.scrollTo(0, targetScrollY);

    saveState({ fromProduct: false });
  }

  // ------------------ save state on product click ------------------
  function bindProductClickSave() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a');
      if (!a) return;

      var href = a.getAttribute('href') || '';
      if (href.indexOf('/products/') !== -1) {
        saveState({ fromProduct: true });
      }
    }, { capture: true });
  }

  // ------------------ boot ------------------
  function init() {
    bindLoadMoreButton();
    armObserver();
    bindProductClickSave();

    // save scroll (throttled)
    var scrollTimer;
    window.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () { saveState(); }, 150);
    }, { passive: true });

    window.addEventListener('pageshow', function () {
      if (shouldRestoreFromBack()) restoreOnBack();
    });

    window.addEventListener('pagehide', function () {
      saveState();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
